import React, { useEffect, useState } from "react";
import "./Home.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import { Link } from "react-router-dom";
import Card from "../../components/card/Card";
import Trending from "../../components/trending/Trending";

const Home = () =>{
    
    const [popularMovies, setPopularMovies] = useState([]);

    useEffect(() => {
        fetch("https://api.themoviedb.org/3/movie/popular?api_key=fd3e0bc6778757d61da0724cce270e32")
        .then(res => res.json())
        .then(data => {
            setPopularMovies(data.results);
            //console.log(data.results);
        });
    },[])

    return (
        
        <div className="poster">
            <Carousel 
                showThumbs = {false}
                autoPlay = {true}
                transitionsTime = {3}
                infiniteLoop = {true}
                showStatus = {false}
            >
                {
                    popularMovies.map(movie => (
                        <Link style={{textDecoration: "none", color:"white"}} to={`movie/${movie.id}`}>
                            <div className="posterImage">
                                <img src={`https://image.tmdb.org/t/p/original${movie && movie.backdrop_path}`} />
                            </div>
                            <div className="posterImage__overlay">
                                <div className="posterImage__title">{movie ? movie.original_title : ""}</div>
                                <div className="posterImage__runtime">
                                    {movie ? movie.release_date : ""}
                                    <span className="posterImage__rating">
                                        {movie ? movie.vote_average : ""}
                                        <i className="fas fa-star" />{" "}
                                    </span>
                                </div>
                                <div className="posterImage__description">
                                    {movie ? movie.overview : ""}
                                </div>
                            </div>
                        </Link>
                    ))
                }   
            </Carousel>
            
            <Trending />

        </div>
       
        
        
        
    )
}

export default Home;